<!--
  name : 김혜진
  desc :
  date : 2020-11-03
-->
<template>
  <v-container id="document" class="con_mpw">
    <!--계약상태 뷰-->
      <div class="chk_doc_type_bar">
        <v-btn class="doc_type_btn_all btn17_C01" v-if="allCheck" @click="allChk"><span class="icon_chk_s"></span>전체</v-btn>
        <v-btn class="doc_type_btn_all btn17_C00" v-else @click="allChk"><span class="icon_chk_s"></span>전체</v-btn>
        <div class="chk_doc_scroll">
          <ul class="doc_type_ulTxtBox">
            <li>
              <v-checkbox class="doc_type_chk"
								v-model="ctrStat"
                label="검토 요청"
                value="PR"
                hide-details
                @click="checkStat()"
              ></v-checkbox>
            </li>
            <li>
              <v-checkbox class="doc_type_chk"
								v-model="ctrStat"
                label="내 서명 대기"
                value="CRR"
                hide-details
                 @click="checkStat()"
              ></v-checkbox>
            </li>
            <li>
              <v-checkbox class="doc_type_chk"
								v-model="ctrStat"
                label="서명 진행"
                value="CRS"
                hide-details
                 @click="checkStat()"
              ></v-checkbox>
            </li>
            <li>
              <v-checkbox class="doc_type_chk"
								v-model="ctrStat"
                label="서명 거부"
                value="CN"
                hide-details
                 @click="checkStat()"
              ></v-checkbox>
            </li>
            <li>
              <v-checkbox class="doc_type_chk"
								v-model="ctrStat"
                label="완료"
                value="CC"
                hide-details
                 @click="checkStat()"
              ></v-checkbox>
            </li>
          </ul>
        </div>
      </div>
    <!--/계약상태 뷰-->
    <!--검색 바-->
    <v-row no-gutters class="search_bar_02 justify-center aling-center">
      <v-col cols="12" sm="5" md="4" lg="4" class="justify-end">
        <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field class="inputH48_02 calendar_at calendar_W_mg dpnone"
              v-model="dateRangeText"
              label="기간"
              placeholder=" "
              prepend-icon="mdi-calendar"
              readonly
              outlined
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
        <v-date-picker
          v-model="dates"
          range
          locale="ko-ko"
        >
            <v-spacer></v-spacer>
            <v-btn class="btn18_00"
              outlined
              @click="$refs.menu.save(dates)"
            >
              확인
            </v-btn>
            <v-btn class="btn18_00"
              outlined
              @click="menu = false"
            >
              취소
            </v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="5" md="6" lg="6" class="justify-center">
        <v-text-field class="inputH48_02 serch_W_mg dpnone"
            v-model="searchText"
            label="검색어"
            placeholder="계약명 입력"
            outlined
            dense
          ></v-text-field>
      </v-col>
      <v-col cols="12" sm="2" md="2" lg="2" class="justify-start">
        <v-btn class="btn17_C01" @click="search()"><span class="icon search"></span></v-btn>
      </v-col>
    </v-row>
    <!--/검색 바-->
    <s-confirm ref="confirm"></s-confirm>
    <contract-list ref="contractList" :searchParams="searchParams !== null?searchParams:null" :key="componentKey"></contract-list>
  </v-container>
</template>
<script>
import contractList from '@/views/contract/contractList/components/contractList'
import moment from 'moment'

export default {
  name: 'document',
  components: {
		contractList
  },
  filters: {
  },
  data () {
    return {
      allCheck: true,
      // 계약상태 체크
      model: null,
      menu: false,
      // date picker
      dates: [],
      // 페이지네이션
			// 계약구분
      ctrSignal: 'company',
      ctrStat: [],
      // 검색 태그 리스트
      searchTags: [],
      searchText: '',
      // 검색 태그 옵션
      searchTagsOption: [],
			searchParams: {
        ctrSignal: '',
        selectDateRange: [],
        ctrStat: [],
        searchText: '',
        pageParam: {
          page: 0,
          size: 2
        }
			},
			// 컴포넌트 강제 리렌더링을 위한 변수 (component의 key 값을 변경함으로써 기존 component가 자신을 다시 초기화하고 재설정한다.)
      componentKey: 0,
      selectAll: false
    }
  },
  computed: {
    dateRangeText () {
      if(this.dates.length === 2) {
        var start = this.dates[0]
        var end = this.dates[1]
        if(start > end) {
          this.dayChange(start, end)
          return this.dates.join(' ~ ')
        }else{
          return this.dates.join(' ~ ')
        }
      }else {
        return this.dates.join(' ~ ')
      }
    },
  },
  created () {
		var orgname = this.$store.state.user.orgname
    if (orgname) {
      this.ctrSignal = 'company'
    } else {
      this.ctrSignal = 'personal'
    }
  },
  mounted () {
    this.track()
    this.$nextTick(() => {
      this.defaultSetting()
      this.search()
    })
  },
  methods: {
    track () {
      this.$gtag.pageview({
        page_path: '/contrackList'
      })
    },
		search() {
      this.searchParams.ctrSignal = this.ctrSignal
      if (this.dateRangeText === null || this.dateRangeText.length === 0 || !this.dateRangeText) {
        this.searchParams.selectDateRange = '1900-01-01 ~ ' + this.getStartNEndDate('end')
      } else {
        this.searchParams.selectDateRange = this.dateRangeText
      }
      if(this.dates.length === 1) {
        this.$refs.confirm.open('alert', '리스트조회', '검색일자를 확인해주세요')
        return
      }
      this.searchParams.ctrStat = this.ctrStat
      this.searchParams.searchText = this.searchText
      // this.componentKey += 1
      // this.componentForceRender()
      this.$refs.contractList.getContractList ()
		},
		// 컴포넌트의 강제 렌더링을 위한 key값 증가시키는 함수
    componentForceRender () {
      this.componentKey += 1
    },
    allChk() {
      if(this.ctrStat.length === 5) {
        this.ctrStat = [];
        this.allCheck = false
      }else{
        this.allCheck = true
        this.ctrStat = [];
        this.ctrStat.push("PR");
        this.ctrStat.push("CRR");
        this.ctrStat.push("CRS");
        this.ctrStat.push("CN");
        this.ctrStat.push("CC");
      }
    },
    checkStat() {
      if(this.ctrStat.length === 5) {
        this.allCheck = true
      }else{
        this.allCheck = false
      }
    },
    // 조회 기간의 기본 시간 세팅 및 검색 기본 파라미터 세팅
    defaultSetting () {
      this.ctrStat.push("PR");
      this.ctrStat.push("CRR");
      this.ctrStat.push("CRS");
      this.ctrStat.push("CN");
      this.ctrStat.push("CC");
      /*
      var date = new Date();
      var year = date.getFullYear();
      var lastyear = date.getFullYear();
      var month = date.getMonth() +1;
      month = month >= 10 ? month : '0' + month;
      var day = date.getDate();
      day = day >= 10 ? day : '0' + day;
      var lastMonth = month -1
      lastMonth = lastMonth >= 10 ? lastMonth : '0' + lastMonth;
      if(month === '01') {
        lastMonth = '12'
        lastyear = year -1
      }

      var start = lastyear + '-' + lastMonth + '-' + day;
      var end =  year + '-' + month + '-' + day;
      */
      // this.dates = [start,end];
      return this.dates.join(' ~ ')

    },
    dayChange(start, end) {
      this.dates = [end, start]
    },
    getStartNEndDate (signal) {
      // 현재일자로부터 1년전 날짜
      const start = moment(new Date()).add(-1,'year').format('YYYY-MM-DD')
      const end = moment(new Date()).add(0,'hour').format('YYYY-MM-DD')
      return signal === 'start'?start:end
    }
  }
}
</script>
<style scoped>
</style>
